import { SettingsValueProps } from './components/settings/type';
import axios from 'axios'
import firebase from 'firebase/compat/app';
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDIn38TAI512pMFNwAtCt8_uvZrp6DNK_M",
  authDomain: "fir-urbia.firebaseapp.com",
  projectId: "fir-urbia",
  storageBucket: "fir-urbia.appspot.com",
  messagingSenderId: "204378899936",
  appId: "1:204378899936:web:e53b68663237544a209785"
};

export const app = firebase.initializeApp(firebaseConfig);
export const storage = getStorage(app);

export const APP_NAME = 'Urbia';
export const LOGO_PATH = '/images/app_logo.png';
export const LOGIN_IMAGE_PATH = '/images/login_image.jpeg';
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const HOST_API = 'https://api.urbia.com.br';
// export const HOST_API = 'http://localhost:2020/';
export const STEP_NAMES = ['Desenho da Gleba', 'Serviços', 'Viabilidade', 'Informações do Terreno', 'Pagamento'];
export const SEND_EMAIL_TO = ["estudos@urbia.com.br"];
// export const SEND_EMAIL_TO = ['guilherme.lague@roxcode.dev'];
export const SEND_ERROR_EMAIL_TO = [''];

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 60,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

export const api = axios.create({
  baseURL: HOST_API,
});

export const oneGB: number = 1073741824;

export const defaultSettings: SettingsValueProps = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeColorPresets: 'blue',
  themeLayout: 'horizontal',
  themeStretch: false,
};

export const serviceValue: any = {
  completeEvu: 3500,
  directorPlan: 500,
  concept: 1750,
  georeferencing: 200,
  dwgStudy: 500,
  downloadStudy: 500,
}

export const geoserverBaseUrl = 'https://apianalises.urbia.com.br/geoserver/';

export const mapView = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

export const satelliteView = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';

export const wmsgs = "https://gs.greatspaces.com.br/geoserver/GreatSpaces/wms?"
